import {BACKEND_API} from '../middleware/backend';
import {getKey} from '../utils/enums';

export const ENUM_REQUEST = 'ENUM_REQUEST';
export const ENUM_SUCCESS = 'ENUM_SUCCESS';
export const ENUM_FAILURE = 'ENUM_FAILURE';

export const ENUMS_REQUEST = 'ENUMS_REQUEST';
export const ENUMS_SUCCESS = 'ENUMS_SUCCESS';
export const ENUMS_FAILURE = 'ENUMS_FAILURE';

export const loadGeneralEnum = (name, filter) => (dispatch, getState) => {
	const key = getKey(name);
	switch (name) {
		// case "entities":
		// case "countries":
		// case "regions":
		// 	const {enums} = getState();
		// 	if (enums[key] && enums[key]["items"] && enums[key]["items"].length) {
		// 		// already loaded, use cache
		// 		return dispatch({
		// 			type: ENUM_SUCCESS,
		// 			key,
		// 			response: {data: enums[key]["items"]}
		// 		})
		// 	}
		// 	break;
		default:
		// just load always
	}

	return dispatch({
		key,
		[BACKEND_API]: {
			types: [ENUM_REQUEST, ENUM_SUCCESS, ENUM_FAILURE],
			endpoint: `enum/${name}`,
			filter: getScopeFilter(filter)
		}
	})
};

export const loadGeneralEnums = (names, filter) => (dispatch, getState) => {
	const key = [];
	let query = "";
	for (let i = 0; i < names.length; i++) {
		if (query.length <= 0) {
			query += "?"
		} else {
			query += "&"
		}
		query += "names=" + names[i];
		key.push(getKey(names[i]));
	}

	return dispatch({
		key,
		[BACKEND_API]: {
			types: [ENUMS_REQUEST, ENUMS_SUCCESS, ENUMS_FAILURE],
			endpoint: `enum/${query}`,
			filter: getScopeFilter(filter)
		}
	})
};

const getScopeFilter = (filter) => {
	const f = {};
	// if (filter.clubId) {
	// 	f.clubId = filter.clubId
	// }
	// if (filter.personalId) {
	// 	f.personalId = filter.personalId
	// }
	return f
};
